module.exports = __webpack_public_path__ + "static/media/corporate-services-img97.b8d129af.jpg";